import type { ReactNode } from "react";
import "./Section.css";

interface SectionProps {
  children: ReactNode;
  tone?: "paper" | "ink" | "dim";
  id?: string;
  className?: string;
}

export default function Section({ children, tone = "paper", id, className = "" }: SectionProps) {
  return (
    <section id={id} className={`section section--${tone} ${className}`.trim()}>
      <div className="container">{children}</div>
    </section>
  );
}
